// Customer Type constants based on API specification
export const CUSTOMER_TYPE = {
  INDIVIDUAL: '10000', // Cá nhân
  BUSINESS: '10001', // Công ty tư nhân (TNHH, CP, hợp danh, liên doanh)
  HOUSEHOLD: '10005', // Hộ kinh doanh cá thể
}

export const CUSTOMER_TYPE_OPTIONS = [
  {
    value: CUSTOMER_TYPE.INDIVIDUAL,
    labelKey: 'stepGuideControl.stepVerifyInfo.formVerifyContract.optionCustomerTypeIndividual',
  },
  {
    value: CUSTOMER_TYPE.BUSINESS,
    labelKey: 'stepGuideControl.stepVerifyInfo.formVerifyContract.optionCustomerTypeBusiness',
  },
  {
    value: CUSTOMER_TYPE.HOUSEHOLD,
    labelKey: 'stepGuideControl.stepVerifyInfo.formVerifyContract.optionCustomerTypeHousehold',
  },
]
